import { IFrameworkResource } from "../../frameworks";
import { IUserResource } from "../../users";
import {
    createApiQueryHook,
    IApiQueryFunction,
    IOrderable,
    IPaginateable,
    mapOrder,
    mapPagination,
} from "../../utils/api";
import { mapRelationalValue, mapRelationalFilter, RelationalFilter, RelationalValue } from "../../utils/filters";
import { serialize } from "../../utils/url";
import { ISkillWithSelfEvaluationsCountList } from "../types";

export interface ISkillWithEvaluationNumbersQueryParameters
    extends IPaginateable, IOrderable<"officialTitle" | "shortTitle" | "createdAt" | "updatedAt" | "rank"> {
    learner: RelationalValue<IUserResource>;
    filters?: {
        officialTitle?: string;
        shortTitle?: string;
        frameworks?: RelationalFilter<IFrameworkResource>;
    };
}

export type ISkillWithEvaluationNumbersQueryResult = ISkillWithSelfEvaluationsCountList;

const mapFilters = (filters: ISkillWithEvaluationNumbersQueryParameters["filters"]) => {
    const { frameworks, officialTitle, shortTitle } = filters ?? {};
    return {
        officialTitle,
        shortTitle,
        "frameworks.uuid": mapRelationalFilter(frameworks),
    };
};

export const skillWithEvaluationNumbersQuery: IApiQueryFunction<ISkillWithEvaluationNumbersQueryParameters> = ({
    learner,
    pagination,
    order,
    filters,
}) => {
    return {
        method: "GET",
        url: `/skills/with-evaluation-numbers-of?uuidLearner=${mapRelationalValue(learner)}${serialize(
            {
                ...mapPagination(pagination),
                ...mapOrder(order),
                ...mapFilters(filters),
            },
            false,
        )}`,
    };
};

export const useSkillWithEvaluationNumbersQuery = createApiQueryHook<
    ISkillWithEvaluationNumbersQueryParameters,
    ISkillWithEvaluationNumbersQueryResult
>(skillWithEvaluationNumbersQuery);
